import { render, staticRenderFns } from "./courseDataTable.vue?vue&type=template&id=7fb7eeb5&scoped=true"
import script from "./courseDataTable.vue?vue&type=script&lang=js"
export * from "./courseDataTable.vue?vue&type=script&lang=js"
import style0 from "./courseDataTable.vue?vue&type=style&index=0&id=7fb7eeb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb7eeb5",
  null
  
)

export default component.exports